var _style, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKorakolpakFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.39 850.39",
    style: {
      enableBackground: "new 0 0 850.39 850.39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#209C3A;}\n\t.st1{fill:#008EB7;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#DA251D;}\n\t.st4{fill:#F7BD29;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h850.39v850.39H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0h850.39v340.16H0V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,285.73h850.39v278.93H0V285.73z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0,292.54h850.39v265.32H0V292.54z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0,309.54h850.39v231.31H0V309.54z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 105.45,
    cy: 142.87,
    rx: 37.42,
    ry: 74.83
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 119.06,
    cy: 142.87,
    rx: 32.31,
    ry: 64.63
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "st2",
    d: "M142.87,179.72h32.31l-26.22,37.98l10.06-61.51l10.06,61.51L142.87,179.72z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a_1_",
    className: "st2",
    d: "M160.3,139.18h32.31l-26.08,37.98l10.06-61.51l10.06,61.51L160.3,139.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a_2_",
    className: "st2",
    d: "M177.73,179.72h32.31l-26.22,37.98l10.06-61.51l10.06,61.51L177.73,179.72z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "b_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a_3_",
    className: "st2",
    d: "M195.17,139.18h32.31l-26.22,37.98l10.06-61.51l10.06,61.51L195.17,139.18z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a_4_",
    className: "st2",
    d: "M212.6,179.72h32.31l-26.22,37.98l10.06-61.51l10.06,61.51L212.6,179.72z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKorakolpakFlag);
export default __webpack_public_path__ + "static/media/KorakolpakFlag.9fe6dffc.svg";
export { ForwardRef as ReactComponent };